{
  "rightSidebar": {
    "placeholder": "This panel is a placeholder.",
    "chat": {
      "placeholder": "Ask about this meal…"
    },
    "favourites": {
      "empty": "Your most-logged meals will appear here once you log some food."
    },
    "tabs": {
      "coach": "Nutrition Coach",
      "recipes": "Recipes",
      "favourites": "Favourites"
    }
  },
  "title": "Meals",
  "subtitle": "Fuel your progress",
  "loading": "Loading...",
  "logMeal": "Log Meal",
  "logMealSubtitle": "Nutrition",
  "mealType": {
    "breakfast": "Breakfast",
    "lunch": "Lunch",
    "dinner": "Dinner",
    "snack": "Snack"
  },
  "type": {
    "BREAKFAST": "Breakfast",
    "LUNCH": "Lunch",
    "DINNER": "Dinner",
    "SNACK": "Snack"
  },
  "empty": {
    "title": "No meals logged",
    "description": "Log your first meal to track nutrition",
    "slotSubtitle": "Not logged yet"
  },
  "logMealAction": "Log meal",
  "addAction": "Add",
  "addAnotherItem": "Add another item",
  "search": "Search",
  "scan": "Scan",
  "macroShort": "C{{carbs}} P{{protein}} F{{fats}}",
  "unnamedMeal": "Unnamed Meal",
  "deleteConfirmation": {
    "description": "Are you sure you want to delete '{{name}}'? This action cannot be undone."
  },
  "form": {
    "title": {
      "create": "Log Meal",
      "detail": "Meal Details"
    },
    "meal": "Meal",
    "selectMeal": "Select Meal",
    "scanBarcode": "Scan Barcode",
    "selectMealButton": "Choose a meal...",
    "consumedAmount": "Amount Consumed",
    "consumedAt": "Date & Time",
    "mealType": "Meal Type",
    "selectMealType": "Select meal type...",
    "nutritionPreview": "Nutritional Information",
    "errors": {
      "mealRequired": "Please select a meal",
      "amountRequired": "Please enter a valid amount"
    }
  },
  "mealSelector": {
    "title": "Select Meal",
    "description": "Search for a meal to log",
    "barcodeResults": "Meals matching scanned barcode",
    "createCustom": "Create Custom Meal",
    "searchPlaceholder": "Search meals...",
    "resultsPlaceholder": "Start typing to search for meals",
    "filters": {
      "all": "All",
      "recent": "Recent",
      "favorites": "Favorites",
      "custom": "Custom",
      "water": "Water"
    }
  },
  "scanner": {
    "title": "Scan Barcode",
    "permissionMessage": "Camera access is required to scan barcodes. Please enable camera permissions to continue.",
    "enableCamera": "Enable Camera"
  },
  "createMeal": {
    "title": "Custom Meal",
    "subtitle": "Add nutritional values and custom servings",
    "nutritionTitle": "Nutritional values",
    "nutritionPer100g": "per 100 g",
    "servingUnits": {
      "title": "Serving units",
      "subtitle": "Custom servings are recalculated automatically from 100 g",
      "baseUnit": "Base unit",
      "count_one": "{{count}} unit",
      "count_other": "{{count}} units",
      "namePlaceholder": "Unit name",
      "weightPlaceholder": "0",
      "addUnit": "Add unit",
      "summary": "≈ {{kcal}} kcal · P {{protein}}g · C {{carbs}}g · F {{fats}}g"
    },
    "fields": {
      "name": {
        "label": "Meal Name",
        "placeholder": "Enter meal name"
      },
      "brand": {
        "label": "Brand (optional)",
        "placeholder": "Enter brand name"
      },
      "barcode": {
        "label": "Barcode",
        "placeholder": "Enter barcode"
      },
      "category": {
        "label": "Category (optional)",
        "placeholder": "Select category"
      },
      "servingSize": {
        "label": "Serving Size",
        "placeholder": "Enter serving size"
      },
      "servingUnit": {
        "label": "Serving Unit",
        "placeholder": "Select serving unit"
      },
      "nutritionalInfo": "Nutritional Information (per 100g)",
      "energyKcal": {
        "label": "Calories (kcal)",
        "placeholder": "Enter calories"
      },
      "protein": {
        "label": "Protein (g)",
        "placeholder": "Enter protein"
      },
      "carbs": {
        "label": "Carbs (g)",
        "placeholder": "Enter carbs"
      },
      "fats": {
        "label": "Fats (g)",
        "placeholder": "Enter fats"
      },
      "fibre": {
        "label": "Fiber (g)",
        "placeholder": "Enter fiber"
      }
    },
    "actions": {
      "cancel": "Cancel",
      "create": "Create Meal",
      "update": "Update Meal"
    }
  },
  "summary": {
    "title": "Daily Nutrition",
    "subtitle": "Your meals for today",
    "totalCalories": "Total Calories",
    "totalProtein": "Protein",
    "totalCarbs": "Carbs",
    "totalFats": "Fats",
    "meals": "Meals",
    "units": {
      "kcal": "kcal",
      "meals": "meals"
    }
  },
  "history": {
    "thisWeek": "This Week",
    "today": "Today",
    "yesterday": "Yesterday",
    "empty": "No meals this week",
    "mealsLogged_one": "{{count}} meal logged",
    "mealsLogged_other": "{{count}} meals logged",
    "ofGoal": "of goal"
  },
  "stats": {
    "title": "Weekly Average",
    "avgCalories": "Avg Calories",
    "avgProtein": "Avg Protein",
    "avgCarbs": "Avg Carbs",
    "avgFats": "Avg Fats"
  },
  "customMeals": {
    "title": "My Meals",
    "add": "Add",
    "empty": "No custom meals yet"
  },
  "favorites": {
    "title": "Favorites",
    "empty": "No favorite meals yet",
    "loggedTimes_one": "Logged {{count}} time",
    "loggedTimes_other": "Logged {{count}} times"
  },
  "nutrition": {
    "title": "NUTRITION",
    "total": "Total",
    "source": "Source",
    "eaten": "eaten",
    "remaining": "remaining",
    "dailyTarget": "daily target",
    "water": "Water",
    "waterProgress": "{{current}} / {{target}}",
    "calories": {
      "longLabel": "Calories"
    },
    "protein": {
      "longLabel": "Protein"
    },
    "carbs": {
      "longLabel": "Carbs",
      "shortSign": "C: {{value}}g"
    },
    "fats": {
      "longLabel": "Fats",
      "shortSign": "F: {{value}}g"
    },
    "fiber": {
      "longLabel": "Fiber",
      "shortSign": "Fi: {{value}}g"
    },
    "kcal": {
      "shortSign": "{{value}}kcal",
      "unit": "kcal"
    },
    "proteins": {
      "shortSign": "P: {{value}}g"
    }
  },
  "units": {
    "GRAMS": {
      "shortSign": "g"
    },
    "KILOGRAMS": {
      "shortSign": "kg"
    },
    "OUNCES": {
      "shortSign": "oz"
    },
    "POUNDS": {
      "shortSign": "lb"
    },
    "MILLILITRES": {
      "shortSign": "ml"
    },
    "LITRES": {
      "shortSign": "l"
    },
    "CUPS": {
      "shortSign": "cup"
    },
    "TABLESPOONS": {
      "shortSign": "tbsp"
    },
    "TEASPOONS": {
      "shortSign": "tsp"
    },
    "PIECES": {
      "shortSign": "pc"
    },
    "SLICES": {
      "shortSign": "slice"
    },
    "FLUID_OUNCES": {
      "shortSign": "fl oz"
    }
  },
  "copy": {
    "action": "Copy",
    "moveAction": "Move",
    "deleteAction": "Delete",
    "actionsLabel": "Meal log actions",
    "selectAction": "Select",
    "dayAction": "Copy day",
    "dayMoveAction": "Move day",
    "slotAction": "Copy {{slot}}",
    "slotMoveAction": "Move {{slot}}",
    "dayActionsLabel": "Day actions",
    "slotActionsLabel": "{{slot}} actions",
    "selection": {
      "title_one": "{{count}} item selected",
      "title_other": "{{count}} items selected",
      "empty": "No items selected",
      "emptyHint": "Pick at least one item",
      "breakdownItem": "{{count}} {{slot}}",
      "breakdownSeparator": " · ",
      "selectAll": "Select all",
      "cancel": "Cancel selection"
    },
    "modal": {
      "title_copy_one": "Copy {{count}} item",
      "title_copy_other": "Copy {{count}} items",
      "title_move_one": "Move {{count}} item",
      "title_move_other": "Move {{count}} items",
      "description": "Pick where they land. Leaving the day as-is keeps each entry exactly where it was recorded.",
      "dayLabel": "Day",
      "dateLabel": "Destination day",
      "dateCaption": "Keeping the source day leaves each recorded time untouched.",
      "slotLabel": "Meal",
      "keepOriginal": "Keep original time",
      "cancel": "Cancel",
      "confirm_copy_one": "Copy {{count}} item",
      "confirm_copy_other": "Copy {{count}} items",
      "confirm_move_one": "Move {{count}} item",
      "confirm_move_other": "Move {{count}} items"
    },
    "summary": {
      "title_copy_one": "Copied {{count}} item",
      "title_copy_other": "Copied {{count}} items",
      "title_move_one": "Moved {{count}} item",
      "title_move_other": "Moved {{count}} items",
      "description": "One line per destination day and slot. Undo is available until you press Done.",
      "line_one": "{{count}} item",
      "line_other": "{{count}} items",
      "lineDestination": "{{day}} · {{slot}}",
      "namesMore": "+{{count}} more",
      "undo": "Undo",
      "done": "Done",
      "undoError": "Couldn't undo just now. Try again, or press Done to keep the change.",
      "degradedDescription": "The details couldn't be shown, but the change went through.",
      "degradedLine_copy": "{{count}} items → copied",
      "degradedLine_move": "{{count}} items → moved"
    }
  }
}
